import { render, staticRenderFns } from "./contentUS.vue?vue&type=template&id=4b615bca&scoped=true&"
import script from "./contentUS.vue?vue&type=script&lang=ts&"
export * from "./contentUS.vue?vue&type=script&lang=ts&"
import style0 from "./contentUS.vue?vue&type=style&index=0&id=4b615bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b615bca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
